<template>
  <div>
    <h3 class="h3Title">SMS 발송</h3>
    <div class="fieldWrap">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">회원 구분</dt>
            <dd class="d-flex align-center">
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchState" :items="userStateItems" item-text="label"
                          item-value="value" label="상태"
                          dense solo flat outlined clearable/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"
                          item-value="roleId" label="역할"
                          dense solo flat outlined clearable/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchGroup" :items="departmentItems" item-value="groupId" item-text="groupName"
                          dense
                          flat
                          solo
                          clearable
                          outlined
                          label="분과"
                          v-on:change="search"/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchGroup" :items="clubItems" item-value="groupId" item-text="groupName"
                          dense
                          clearable
                          flat
                          solo
                          outlined
                          label="동호회"
                          v-on:change="search"/>
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">포함할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => param.searchIncludeUsers = v"  />
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">제외할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => param.searchExcludeUsers = v"  />
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">SMS수신동의</dt>
            <dd class="checkSt">
              <v-radio-group class="formInRadio" v-model="param.searchSmsReceive" :mandatory="true" row>
                <v-radio label="전체"/>
                <v-radio label="수신 동의" :value="true"/>
                <v-radio label="수신 거부" :value="false"/>
              </v-radio-group>
<!--              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">검색 키워드</dt>
            <dd class="checkSt">
              <v-col sm="6">
                <v-text-field label="아이디/이름/이메일/휴대폰번호 검색"
                              v-model="param.searchKeyword" v-on:keyup.enter="search"
                              dense clearable flat outlined
                />
              </v-col>
              <!--              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
            </dd>
          </dl>
        </li>
        <li class="searchBtn">
          <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>
        </li>
      </ul>
    </div>
    <h3 class="h3Title">수신자 목록</h3>
    <div class="d-flex">
      <div class="tableBx">
        <div class="tableBtnBx">
          <p class="searchAll">
            <v-checkbox class="mgr" label="" v-model="allSelected">
              <template v-slot:label>검색 된 총 <span class="txtPoint"> {{ totalItems }}명 </span> 선택</template>
            </v-checkbox>
          </p>
          <div class="tableBtn">
            <ul>
              <li class="tableBtnList" v-if="!allSelected">
                <span class="black-color">{{ selected != null ? selected.length : 0 }}</span> 명 선택됨
              </li>
              <li class="tableBtnList" v-if="allSelected"><span class="red--text">검색된 전체 회원 선택됨</span></li>
              <li class="tableBtnList" style="width: 400px">
                <vue-tags-input
                    v-model="includeMobileNo"
                    :tags="includeMobileNos"
                    @tags-changed="addMobileNo"
                    :validation="[{
                      classes: 'no-numbers',
                      rule: /^[0][1][0,1,6,7,8,9]\d{7,8}$/,
                      disableAdd: true
                    }]"
                    placeholder="추가 핸드폰 번호만 입력 후 enter"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="">
          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="userList"
              :server-items-length="totalItems"
              :options.sync="options"
              :loading="listLoading"
              item-key="userId"
              show-select
              class="elevation-1"
              :footer-props="{showFirstLastPage: true}"
              disable-sort
          >
            <template v-slot:item.state="{value}">
              {{ userStateItems.filter(i => i.value === value)[0].text }}
            </template>
            <template v-slot:item.userHasRoles="{value}">
              <!--            {{ $t(value) }}-->
              <span
                  class="d-inline-block text-truncate"
                  style="max-width: 100px;"
              >
              {{ value.length > 0 ? value.length > 1 ? value[0].role.roleName + ' 외 ' + (value.length-1)  : value[0].role.roleName : '' }}
                <!--              <template v-for="(role, index) in item.userHasRoles"><span v-if="index !== 0"  :key="index">, </span>{{role.role.roleName}}</template>-->
            </span>

            </template>
            <template v-slot:item.userId="{value}">
                {{ value.length > 12 ? value.substring(0, 12) + "..." : value }}
            </template>
            <template v-slot:item.birthDate="{value, item}">
              {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
            </template>

            <template v-slot:item.createdAt="{ value }">
              {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
            </template>

            <template v-slot:item.departmentGroup="{value}">
              {{  userGroupName(value) }}
            </template>
            <template v-slot:item.clubGroup="{value}">
              {{  userGroupName(value) }}
            </template>

          </v-data-table>
        </div>
      </div>

      <mobile-component
          :param="param"
          :all-selected="allSelected"
          :selected="selected"
          :include-mobile-list="includeMobileList"
          :template-data="templateData"
      />
    </div>

    <h3 class="h3Title">문자 템플릿</h3>
    <div class="fieldWrap mgb2">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">제목</dt>
            <dd>
              <v-col sm="6">
                <v-text-field label="" v-model="templateParam.title" v-on:keyup.enter="getTemplateList()" dense solo
                              clearable flat outlined/>
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="searchBtn">
          <v-btn color="#424964" @click="getTemplateList()" depressed dark>검색</v-btn>
        </li>
      </ul>
    </div>
    <div class="d-flex justify-end mgb3">
      <v-btn class="vBtn vIconResize mgr" color="#666" dark @click="deleteTemplate">
        <v-icon class="" left>mdi mdi-playlist-remove</v-icon>
        삭제
      </v-btn>
      <v-btn class="vBtn vIconResize" color="#666" dark @click.stop="TemplateDialog = true">
        <v-icon class="" left>mdi mdi-playlist-plus</v-icon>
        템플릿 신규 등록
      </v-btn>
      <TemplateDialog :visibleTamplate="TemplateDialog" @close="closeTemplateDialog"/>
    </div>

    <div class="d-flex flex-wrap">
      <template v-if="templateList.length > 0">
        <div class="smsTemplateBx" v-for="(item, index) in templateList" :key="item.id">
          <ul>
            <li class="smsTemplateList">
              <h4 class="templateTit checkSt">
                <template v-if="!item.isTemplateTit">
                  <div class="d-flex">
                    <v-checkbox class="mgr" v-model="item.check"/>
                    <v-col class="disabledField userDd" sm="3">
                      <v-text-field :label="item.title" dense solo flat clearable disabled/>
                    </v-col>
                  </div>
                  <v-btn class="" color="#f8f8f8" icon depressed @click="editTile(item, true)">
                    <v-icon color="#1976d2">mdi mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <v-col class="" sm="3">
                    <v-text-field :label="item.title" v-model="item.title" dense solo flat outlined clearable/>
                  </v-col>
                </template>
              </h4>
              <div class="templateAreaBx">
                <p>
                  <v-col class="textAreaH">
                    <v-textarea
                        name="input-7-1"
                        :label="item.contents"
                        v-model="item.contents"
                        value=""
                        hint="Hint text"
                        solo
                        flat
                        outlined
                    />
                  </v-col>
                </p>
                <p class="descTxt d-flex justify-end mgb">(SMS
                  {{ item.contents == null ? "" : item.contents.length }}/90)</p>
                <div class="bestTxt d-flex justify-space-between align-center mgb2">

                  <em class="best d-flex align-center vIconResize">
                                        <span v-if="index < 3">
                                            <v-icon class="mgr" color="#2196f3">mdi mdi-crown</v-icon>
                                            BEST
                                        </span>
                  </em>
                  <span>사용 건 수 : {{ item.sendCount }}건</span>
                </div>
                <div v-if="item.isTemplateTit">
                  <v-btn class="vBtn mgr" color="#1991eb" dark @click="templateUpdate(item)">
                    <v-icon left>mdi mdi-content-save</v-icon>
                    저장
                  </v-btn>
                  <v-btn class="vBtn" color="#fafafa" @click="editTile(item, false)">
                    <v-icon left>mdi mdi-close</v-icon>
                    취소
                  </v-btn>
                </div>
                <div v-else class="d-flex justify-space-around">
                  <v-btn class="vBtn" color="#1991eb" dark @click="selectTemplate(item)">
                    <v-icon left>mdi mdi-check</v-icon>
                    템플릿 선택
                  </v-btn>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>
    <template v-if="templateList.length > 0">
      <div class="text-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="8">
              <v-container class="max-width">
                <v-pagination
                    v-model="templatePageOptions.page"
                    class="my-4"
                    :length="templatePageOptions.length"
                    :total-visible="templatePageOptions.visible"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                ></v-pagination>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
    <template v-if="templateList.length == 0">
      <p class="d-flex justify-center tableWrap">
        등록 된 템플릿이 없습니다.
      </p>
    </template>


  </div>
</template>

<script>
import userApi from '@/api/UserApi'
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";
import smsApi from '@/api/SmsApi';

import userSearchComponent from "@/views/component/UserSearchComponent";
import mobileComponent from "@/views/component/MobileComponent";

import _ from 'lodash';
import VueTagsInput from '@johmun/vue-tags-input';

import TemplateDialog from "./dialog/TemplateDialog";

export default {
  name: "SmsSend",
  components: {
    TemplateDialog, VueTagsInput, userSearchComponent, mobileComponent
  },
  data: () => ({
    TemplateDialog: false,
    user: {},
    userType: [{text: '전체', value: null}, {text: '1 회원', value: false}, {text: '2 회원', value: true}],
    userStateItems: [],
    userRoleItems: [],
    departmentItems:[],
    clubItems:[],
    sms: {
      includeUserList: [],
      exceptUserList: []
    },
    templateParam: {
      title: null,
      system: false
    },
    templateData: {
      templateId: null
    },
    includeMobileList: [],
    includeUser: '',
    includeMobileNo: '',
    exceptUser: '',
    includeMobileNos: [],
    users:[],
    listLoading: true,
    allSelected: false,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    templatePageOptions: {
      page: 1,
      itemsPerPage: 4,
      length: 0,
      visible: 10
    },
    templateList: [],
    templateTotalItems: 0,
    totalItems: 0,
    singleSelect: false,
    param:{},
    selected: [],
    headers: [
      {text: '역할', value: 'userHasRoles', align: 'left'},
      {text: '이름', value: 'name', align: 'left'},
      {text: '아이디', value: 'userId', align: 'left'},
      {text: '분과', value: 'departmentGroup', align: 'left'},
      {text: '동호회', value: 'clubGroup', align: 'left'},
      {text: '휴대폰번호', value: 'mobileNo'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
      {text: '생년월일', value: 'birthDate'},
      {text: '이메일', value: 'email', align: 'left'}
    ],
    userList: [],
    hourList: [],
    minuteList: [],
    searchUserKeyword:null,
    attachFileServerUrl: process.env.VUE_APP_ATTACH_FILE_SERVER_URL,
    waitingSearch: false
  }),
  computed: {},
  watch: {
    options: {
      handler() {
        this.search()
      },
      deep: true,
    },
    templatePageOptions: {
      handler() {
        this.getTemplateList();
      },
      deep: true
    },
  },
  methods: {
    userGroupName(value) {
      const approvalList = value?.filter(v => v.joinState === 'STATE_APPROVAL')??[];
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    search() {
      this.listLoading = true;
      const params = {...this.param, ...this.options};
      if (this.activeItem > 0) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      // params.ids = this.ids;
      params.searchIncludeUsers = this.param.searchIncludeUsers?.map(o => o.userId)??null;
      params.searchExcludeUsers = this.param.searchExcludeUsers?.map(o => o.userId)??null;
      params.searchSmsReceive = (this.param.searchSmsReceive === true || this.param.searchSmsReceive === false) ? this.param.searchSmsReceive : null;
      // if (params.isSmsReceive == 0) {
      //   params.smsReceived = null;
      // }

      userApi.list(params).then(data => {
        this.userList = data.content;
        // this.selected = [...this.selected, ...this.userList]
        this.totalItems = data.totalElements;
        this.listLoading = false;
        this.selected = [];
      });

    },
    addMobileNo(value) {
      this.includeMobileList = value.map(v => v.text);
    },
    async getTemplateList() {
      const {page, itemsPerPage} = this.templatePageOptions;
      let params = this.templateParam;

      params.page = (page - 1);
      params.size = itemsPerPage;

      let data = await smsApi.getTemplateList(params);
      this.templateList = data.content;

      this.templateTotalItems = data.totalElements;
      this.templatePageOptions.length = data.totalPages;
    },
    editTile(item, tit) {
      item.isTemplateTit = tit;
      this.templateList = _.cloneDeep(this.templateList);
    },
    templateUpdate(item) {
      const param = {
        smsTemplateId: item.smsTemplateId,
        title: item.title,
        contents: item.contents
      }
      smsApi.updateTemplate(param).then(data => {
        alert("수정되었습니다.");
        if (data) this.editTile(item, false);
      });
    },
    closeTemplateDialog() {
      this.TemplateDialog = false;
      this.getTemplateList();
    },
    selectTemplate(item) {
      // console.log(item);
      this.templateData.templateId = item.smsTemplateId;
      this.templateData.subject = item.title;
      this.templateData.content = item.contents;
      // this.$refs.sendInput.focus();
    },
    deleteTemplate() {
      var templateList = this.templateList;

      var list = [];
      templateList.forEach(data => {
        if (data.check) {
          list.push(data.smsTemplateId);
        }
      });

      if (list.length === 0) {
        alert("삭제할 템플릿을 선택해주세요.");
        return;
      }

      smsApi.deleteTemplate(list).then(data => {
        alert("삭제되었습니다.");
        if (data) {
          this.getTemplateList();
        }
      });
    }
  },
  created: function () {
    this.ids = this.$route.params.ids;

    // this.search();

    this.getTemplateList();

    userApi.stateList().then(data => {
      // console.log(data);
      this.userStateItems = data;
    });
    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h3Title {
  @include h3-title;
}

.col {
  padding: 0;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
          flex: 0 0 80px;
        }

        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.tableBtnBx {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .searchAll {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    /*font-size: 13px;*/
    .txtPoint {
      color: $point-color;
    }
  }
}

.tableBx {
  flex: 1 auto;
  margin-right: 30px;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }
}

.ti-new-tag-input {
  font-size: 12px;
}

.mobileBX {
  width: 300px;

  .bxLine {
    position: relative;
    padding: 34px 10px;
    border: 1px solid #dcdee3;
    border-radius: 30px;
    box-shadow: 0 3px 6px #eee;

    &::before {
      content: '';
      position: absolute;
      top: 15px;
      left: 120px;
      width: 135px;
      height: 15px;
      background: url('~@/assets/images/common/bg_sms_phone02.png') no-repeat;
    }

    .bxBg {
      padding: 20px 15px;
      background: #f8f8fa;
      font-size: 12px;
      font-family: 'dotum', sans-serif;

      .smsDetailInfo {
        padding: 14px 10px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.38);
        background: #fff;

        dl {
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0;
          }

          dt {
            flex: 0 0 62px;
            width: 62px;
          }
        }
      }

      .select {
        .mgr {
          margin-right: 4px !important;
        }
      }
    }
  }
}

.smsTemplateBx {
  width: 23%;
  margin-right: 2.6%;
  border: 1px solid #dcdee3;
  background: #f8f8f8;
  margin-bottom: 25px;

  &:nth-of-type(4n) {
    margin-right: 0;
  }

  ul {
    padding: 15px;
  }

  .templateTit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 5px;
    border-bottom: 1px solid #dcdee3;
  }

  .descTxt {
    font-size: 12px;
    color: #666;
  }

  .bestTxt {
    font-size: 12px;

    .best {
      color: #2196f3;
    }
  }

}

</style>
